
import { Vue, Component, Prop, Watch, Inject } from 'vue-property-decorator'

@Component({
  name: 'PublicFormItem',
})
export default class PublicFormItem extends Vue {
  @Prop({
    type: [Number, Object],
    default: 24,
  })
  private readonly sm!: unknown | number

  @Prop({
    type: [Number, Object],
    default: 24,
  })
  private readonly md!: unknown | number
  @Prop({
    type: [Number, Object],
    default: 24,
  })
  private readonly xl!: unknown | number

  @Prop({
    type: [Number, Object],
    default: 24,
  })
  private readonly xxl!: unknown | number
  @Prop({
    type: [Number, Object],
  })
  private span
  @Prop({
    type: Boolean,
    default: () => false,
  })
  private labelBorder // label底部border
  @Prop({
    type: String,
    default: () => '',
  })
  private label
  @Prop({
    type: Boolean,
    default: () => false,
  })
  private required

  @Prop({
    type: Boolean,
    default: () => false,
  })
  private isFormItem

  @Inject({ from: 'isForm', default: () => false })
  private isForm!: boolean

  private privateRequired = false

  @Watch('$attrs.rules', { immediate: true })
  private rulesChange(rules) {
    if (rules) {
      if (Array.isArray(rules)) {
        this.privateRequired = rules.some((v) => v.required)
      } else {
        this.privateRequired = rules.required
      }
    }
  }
}
